import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-58MJM05F2Q'); // 본인의 측정 ID로 교체
};

export const sendPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// 이벤트 추적 함수
export const trackEvent = ({ category, action, label, value }: { category: string; action: string; label?: string; value?: number }) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
